import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  public text: string = 'Loading';
  constructor(
    public spinner: NgxSpinnerService
  ) {

  }
  show(text?: string) {
    this.text = text ? text : 'Loading';
    this.spinner.show();
  }
  hide() {
    this.text = 'Loading';
    this.spinner.hide();
  }
}
